/**
 * Constants for MsDropDownButton component
 */

// Valid button types
export const VALID_DROPDOWN_BUTTON_TYPES = [
  'primary',
  'secondary', 
  'third',
  'four'
]

// Default props values
export const DEFAULT_PROPS = {
  text: null,
  leftIcon: null,
  rightIcon: 'chevron-down-white',
  type: 'primary',
  disabled: false,
  maxHeight: null,
  menuItems: [],
  classCustom: '',
  customPositionMenu: false,
  customWidth: 0,
  heightOffset: 5,
  widthOffset: 25,
  hasShowMenu: true,
  tooltipText: null,
  hasBorder: false,
  hasBorderParent: false,
  isBtnFooterHelpFul: false,
  classRoot: ''
}

// CSS class names - separating into individual classes for better testing
export const CSS_CLASSES = {
  // Base classes
  DROP_DOWN_BUTTON: 'drop-down-button',
  FLEX_CENTER: 'flex-center',
  
  // State classes
  BORDER_PARENT: 'border-drop-down-btn',
  DISABLED: 'disabled-btn',
  FOOTER_HELPFUL: 'btn-footer-helpful',
  
  // Widget classes
  WIDGET_MORE_CONTAINER: 'widget-more-container',
  WIDGET_BTN: 'widget-btn',
  
  // Button classes
  BTN: 'btn',
  FLEX_ROW: 'flex-row',
  PRIMARY_BUTTON: 'primary-button',
  BORDER_NONE: 'btn-border-none',
  WIDGET_MORE: 'widget-more',
  
  // Icon and text classes
  ICON_24: 'icon24',
  ICON: 'icon',
  LEFT: 'left',
  TEXT: 'text',
  BUTTON_LINE: 'button-line',
  FOOTER: 'footer'
}

// Event names
export const EVENTS = {
  MENU_CLICK: 'menuClick'
}
